import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import ACL from '@components/ACL/ACL'

import Action from '@components/Action'
import Delete from '@components/Icon/Delete'
import Edit from '@components/Icon/Edit'
import Add from '@components/Icon/Add'
import Activity from '@components/Icon/Activity'
import Block from '@components/Icon/Block'
import { showDialog, isCancellationError } from '@components/Dialog'

class ClientProfileActions extends Component {
  static propTypes = {
    clientContactStore: PropTypes.object,
    contact: PropTypes.object,
    modalStore: PropTypes.object,
    history: PropTypes.object,
    growlStore: PropTypes.object,
    commentStore: PropTypes.object
  }

  deleteClient = (clientId, clientTitle, clientName) => {
    const { history, growlStore } = this.props
    return showDialog({
      title: 'Delete this client from contacts?',
      text: `${clientTitle} ${clientName}`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete'
    })
      .then(result => {
        return this.props.clientContactStore
          .deleteClientContact(clientId)
          .then(() => {
            history.push('/client-contact-search')
          })
      })
      .catch(err => {
        if (isCancellationError(err)) return
        growlStore.showError(err, `Couldn't delete client ${clientName}`)
      })
  }

  handleStatusChange = contact => {
    const { commentStore, clientContactStore } = this.props
    this.props.modalStore.show({
      type: 'CLIENT_CONTACT_STATUS_CHANGE_COMMENT',
      props: {
        contact,
        clientContactStore,
        commentStore
      }
    })
  }

  render () {
    const { contact, clientContactStore } = this.props
    return (
      <div className='actions-wrapper'>
        <ul className='actions'>
          <SetStatus
            status={contact.status}
            onClick={() => this.handleStatusChange(contact)}
          />
          <li className='action'>
            <Action
              onClick={e => {
                return this.props.modalStore.show({
                  type: 'PROJECT_FORM',
                  props: {
                    title: 'Set EPL status to Canceled',
                    cancelText: 'Cancel',
                    okText: 'Create',
                    contact
                  }
                })
              }}
            >
              <Add />
              <span>Create new project</span>
            </Action>
          </li>
          <li className='action' data-cy='edit-client-btn'>
            <Action
              onClick={e => {
                return this.props.modalStore.show({
                  type: 'CLIENT_CONTACT_FORM',
                  props: {
                    contact,
                    onSaveSuccess: savedContact => {
                      clientContactStore.getContact(savedContact.id)
                      this.props.modalStore.close()
                    }
                  }
                })
              }}
            >
              <Edit />
              <span>Edit</span>
            </Action>
          </li>
          <li className='action'>
            <Action
              onClick={() => {
                this.deleteClient(contact.id, contact.title, contact.fullName)
              }}
            >
              <Delete />
              <span>Delete</span>
            </Action>
          </li>
        </ul>
      </div>
    )
  }
}

function SetStatus ({ onClick, status }) {
  return (
    <ACL inline roles={status ? ['Admin', 'ProjectManagement'] : ['Admin']}>
      <li className='action m-l-lg' onClick={onClick}>
        {status ? <Block /> : <Activity />}
        <span>Set {status ? 'inactive' : 'active'}</span>
      </li>
    </ACL>
  )
}

SetStatus.propTypes = {
  onClick: PropTypes.func,
  status: PropTypes.bool
}

export default withRouter(
  inject('modalStore', 'growlStore')(observer(ClientProfileActions))
)
